import { Tab, TabList, Tabs } from "@carbon/react";

// import { IQuickTableFilterTabsViewProps } from './QuickTableFilterTabs';
import { Select } from "../Select";
import { InfoIcon } from "../InfoIcon";

export const View = ({
  containerClassName = "",
  defaultSelectedIndex,
  selectedIndex,
  onChange,
  queryStringTabNavLinks,
  setQueryStringFilter,
  // tabListType,
}) => {
  return (
    <>
      {/* Display Tabs in Medium Screens & Above */}
      <Tabs
        defaultSelectedIndex={defaultSelectedIndex}
        selectedIndex={selectedIndex}
        onChange={onChange}
      >
        <TabList
          activation="manual"
          // tabListType={tabListType}
          aria-label="List of tabs"
          className={`${containerClassName} quicktable-filter-tabs`}
        >
          {queryStringTabNavLinks.options.map((qst) => (
            <Tab
              key={qst.value}
              onClick={() =>
                setQueryStringFilter(queryStringTabNavLinks.query, qst.value)
              }
            >
              {qst.key}{" "}
              {!qst.description ? null : <InfoIcon message={qst.description} />}
            </Tab>
          ))}
        </TabList>
      </Tabs>

      {/* Display SelectDropDown in Mobile Screens */}
      <div className="table-filter--sm">
        <Select
          name="tableFilterSelect"
          label=""
          title="Filter Table"
          placeholder="Filter Table"
          className="font-ctm--bold mr-3 table-filter--select"
          selectItems={queryStringTabNavLinks.options.map((qst) => ({
            text: qst.key,
            value: qst.value,
          }))}
          defaultValue={queryStringTabNavLinks.options[0].value}
          onChange={(e) => {
            setQueryStringFilter(queryStringTabNavLinks.query, e.target.value);
            onChange({
              selectedIndex:
                queryStringTabNavLinks.options.findIndex(
                  (op) => op.value === e.target.value
                ) || 0,
            });
          }}
          value={
            queryStringTabNavLinks.options.find(
              (op, ind) => ind === selectedIndex
            )?.value
          }
        />
      </div>
    </>
  );
};
